<!-- #86 -->
<template>
  <v-col class="mx-4 py-0 mt-2">
    <v-dialog
      v-model="openStatusDialog"
      max-width="550px"
      close-delay="ma-5"
      @keydown.esc="openStatusDialog = false"
    >
      <v-card>
        <v-card-title> Update Status</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form">
            <v-col>
              <v-autocomplete
                label="Select Status"
                :items="statusType"
                v-model="selectedApplicationStatus"
                :rules="[(v) => !!v || 'Status is required.']"
                class="required mt-0 pt-0"
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-text-field
                v-if="selectedApplicationStatus == 'Rejected'"
                label="Comment"
                v-model="comment"
                class="mt-0 pt-0 required"
                :rules="[(v) => !!v || 'Comment is required.']"
              >
              </v-text-field>
              <v-text-field
                v-else
                label="Comment"
                v-model="comment"
                class="mt-0 pt-0"
              >
              </v-text-field>
            </v-col>
          </v-form>
          <v-card-action>
            <v-btn
              small
              color="primary"
              class="ml-2"
              :disabled="selectedApplicationStatus == null"
              @click="updateApplicationStatus"
              >Update</v-btn
            >
            <v-btn
              small
              color="error"
              class="ml-4"
              @click="
                (selectedApplicationStatus = null),
                  (openStatusDialog = false),
                  $refs.form.reset()
              "
              >Cancel</v-btn
            >
          </v-card-action>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="updatePopup"
      max-width="550px"
      close-delay="ma-5"
      @keydown.esc="updatePopup = false"
    >
      <v-card>
        <v-card-title> Update Status</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-col>
            <v-autocomplete
              label="Select Status"
              :items="statusType"
              v-model="selectedStatus"
              :rules="[(v) => !!v || 'Status is required.']"
              class="required mt-0 pt-0"
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field
              v-if="selectedStatus == 'Rejected'"
              label="Comment"
              v-model="rowcomment"
              class="mt-0 pt-0 required"
              :rules="[(v) => !!v || 'Comment is required.']"
            >
            </v-text-field>
            <v-text-field
              v-else
              label="Comment"
              v-model="rowcomment"
              class="mt-0 pt-0"
            >
            </v-text-field>
          </v-col>
          <v-card-action>
            <v-btn
              small
              color="primary"
              class="ml-2"
              @click="updateStatus"
              :disabled="selectedStatus == null"
              >Update
            </v-btn>
            <v-btn
              small
              color="error"
              class="ml-4"
              @click="(selectedStatus = null), (updatePopup = false)"
              >Cancel</v-btn
            >
          </v-card-action>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      max-width="850px"
      close-delay="ma-5"
      @keydown.esc="dialog = false"
    >
      <v-card>
        <v-card-title>
          Employee Wise Timesheet
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-data-table
            :headers="_detailsHeaders"
            :items="detailsData"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :loading="rsaLoader"
            class="elevation-1 mt-7"
            :items-per-page="100"
            :footer-props="{
              itemsPerPageOptions: [100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template v-slot:[`item.employee_type`]="{ item }">
              <span v-if="item.sub_role_of_employee">
                {{ item.employee_type }} ({{ item.sub_role_of_employee }})
              </span>
              <span v-else>{{ item.employee_type }}</span>
            </template>
            <template v-slot:[`item.overtime_flag`]="{ item }">
              {{ item.overtime_flag == 1 ? "Yes" : "No" }}
            </template>
            <template v-slot:[`item.total_min_worked`]="{ item }">
              {{ changeNumberFormat(item.worked_hour) }} (
              {{ changeNumberFormat(item.total_min_worked) }})
            </template>
            <template v-slot:[`item.overtime_cost`]="{ item }">
              {{ changeFormat(item.overtime_cost) }}
            </template>
            <template v-slot:[`item.overtime_hour`]="{ item }">
              {{ changeNumberFormat(item.overtime_hour) }}
            </template>
            <template v-slot:[`item.worked_hour`]="{ item }">
              {{ changeNumberFormat(item.worked_hour) }}
            </template>
            <template v-slot:[`item.worked_hour`]="{ item }">
              {{ changeNumberFormat(item.worked_hour) }}
            </template>
            <template v-slot:[`item.worked_minutes`]="{ item }">
              {{ changeNumberFormat(item.worked_minutes) }}
            </template>
            <template v-slot:[`item.worked_minutes`]="{ item }">
              {{ changeNumberFormat(item.worked_minutes) }}
            </template>

            <template v-slot:[`item.total_cost`]="{ item }">
              {{ changeFormat(item.total_cost) }}
            </template>
            <template v-slot:[`item.start_date_time`]="{ item }">
              {{ item.start_date_time | moment("DD MMM, YYYY hh:mm A") }}
            </template>
            <template v-slot:[`item.end_date_time`]="{ item }">
              {{ item.end_date_time | moment("DD MMM, YYYY hh:mm A") }}
            </template>
            <template v-slot:[`item.is_approved`]="{ item }">
              {{
                item.is_approved == 1
                  ? "Accepted"
                  : item.is_approved == 2
                  ? "Rejected"
                  : item.is_approved == 3
                  ? "Inactive"
                  : item.is_approved == 0
                  ? "Open"
                  : ""
              }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-tooltip
                bottom
                v-if="
                  checkPermission(
                    'app_osl_overtime_cost:employee_status_update'
                  ) && item.is_approved == 0
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="openUpdate(item)"
                  >
                    mdi-update
                  </v-icon>
                </template>
                <span>Update status</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5 mt-4"
        style="color: #23468c; font-weight: 500; width: 100%"
      >
        List of Timesheet(s)
      </div>
      <v-spacer></v-spacer>
      <v-btn small color="primary" class="mt-4" @click="pendingApproval"
        >Pending Approval</v-btn
      >
      <v-btn
        small
        color="primary"
        class="mt-4 ml-4"
        @click="$router.push('/vendor/timesheet')"
        >Add Timesheet</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-2"></v-divider>

    <v-data-table
      :headers="_headers"
      :items="list"
      :options.sync="options"
      :server-items-length="total"
      :loading="loader"
      class="elevation-1 mt-7"
      :items-per-page="25"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.status`]="{ item }">
        {{
        item.status == "Open"
            ? "Open"
            : item.status == "Closed"
            ? "Closed"
            : item.status == "Inactive"
            ? "In-Active"
            : item.status == "In-Progress"
            ? "In Progress"
            : "",

        }}
      </template>
      <template v-slot:[`item.total_cost`]="{ item }">
        {{ changeFormat(item.total_cost) }}
      </template>
      <template v-slot:[`item.total_employee`]="{ item }">
        {{ changeNumberFormat(item.total_employee) }}
      </template>
      <template v-slot:[`item.date_of_attendance`]="{ item }">
        {{ item.date_of_attendance | moment("DD MMM, YYYY") }}
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip
          bottom
          v-if="
            checkPermission(
              'app_osl_overtime_cost:request_application_employee_list'
            )
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="editDetails(item)"
            >
              mdi-eye
            </v-icon>
          </template>
          <span>View Application</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="updateStatusAction(item)"
              v-if="
                checkPermission(
                  'app_osl_overtime_cost:request_application_status_update'
                ) &&
                userCategory.user_category === 3 &&
                (item.status == 'Open' || item.status == 'In-Progress')
              "
            >
              mdi-update
            </v-icon>
          </template>
          <span>Update status</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-switch
              class="mt-0 pt-0"
              v-model="item.status"
              v-bind="attrs"
              v-on="on"
              @change="confirmStatusChange(item)"
              v-if="
                (checkPermission(
                  'app_osl_overtime_cost:request_application_inactive'
                ) &&
                  item.status == 'Open') ||
                item.status == false
              "
            ></v-switch>
          </template>
          <span>Change Status</span>
        </v-tooltip>
      </template>

      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col md="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  label="Vendor Name"
                  :items="vendors"
                  v-model="selectedVendor"
                  item-text="vendor_name"
                  item-value="id"
                  hide-details
                  @focus="getvendorList"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  label="Status"
                  :items="vendorStatus"
                  v-model="statusArr"
                  item-text="text"
                  item-value="value"
                  outlined
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateFilter"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateFilter = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateFilterTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateFilterTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col class="text-right">
                <v-btn class="success" color="primary" @click="searchAll"
                  >Search</v-btn
                >
                <v-btn color="white" class="ml-4" @click="allClear"
                  >Clear</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="my-5"></v-divider>
        </template>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="dialogConfirm"
      :text="'Are you sure you want to inactive this sheet'"
      :loader="statusLoader"
      @confirm="confirmAction"
      @close="closeConfirm"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";
export default {
  mounted() {
    this.getvendorList();
  },
  components: {
    ConfirmDialog,
  },
  data: () => ({
    closedclick: false,
    dialogConfirm: false,
    dateFilterTo: false,
    dateFilter: false,
    from_date: null,
    to_date: null,
    updateItem: "",
    selectedApplicationStatus: null,
    active: false,
    statusArr: [],
    statusType: ["Approved", "Rejected"],
    selectedStatus: null,
    previusPage: false,
    updatePopup: false,
    dialog: false,
    detailsData: [],
    optionsDetails: {
      page: 1,
      itemsPerPage: 100,
      sortDesc: [false],
    },
    selectedVendor: null,
    vendors: [],
    saveLoader: false,
    vendorStatus: [
      { text: "Open", value: 0 },
      { text: "Closed", value: 1 },
      { text: "In-Active", value: 2 },
      { text: "In Progress", value: 3 },
    ],

    detailsHeaders: [
      {
        text: "Vendor name",
        value: "osl_vendor_id_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Employee Name",
        value: "employee_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Type",
        value: "employee_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Type of day",
        value: "type_of_day",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Start date",
        value: "start_date_time",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "End date",
        value: "end_date_time",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Overtime Cost (In AED)",
        value: "overtime_cost",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Overtime",
        value: "overtime_flag",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Overtime (In Hours)",
        value: "overtime_hour",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Worked Hours",
        value: "worked_hour",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Worked Minutes",
        value: "worked_minutes",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Total time in hours (mins)",
        value: "total_min_worked",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Total cost (In AED)",
        value: "total_cost",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Status",
        value: "is_approved",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "Vendor Name",
        value: "osl_vendor_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Total Cost (In AED)",
        value: "total_cost",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Total Employee",
        value: "total_employee",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Attendance Date",
        value: "date_of_attendance",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created by",
        value: "uploaded_by",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated by",
        value: "updated_by",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],

    list: [],
    options: {},
    totals: 0,
    total: 0,
    openStatusDialog: false,
    applicationItem: "",
    comment: null,
    rowcomment: null,
    rejectedItem: {},
  }),

  watch: {
    // dialog(val) {
    //   val || this.close();
    // },
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
    optionsDetails: {
      handler() {
        if (this.optionsDetails.page !== 1 || this.previusPage) {
          this.previusPage = true;
          if (this.item !== undefined) this.editDetails(this.item);
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.userCategory.user_category == 5) {
      this.fetchList();
    }
  },
  computed: {
    _detailsHeaders() {
      return this.detailsHeaders.filter((i) => {
        if (this.userCategory.user_category == 5) {
          if (i.value !== "overtime_cost" && i.value !== "total_cost") {
            return true;
          }
        } else {
          return true;
        }
      });
    },
    _headers() {
      return this.headers.filter((i) => {
        if (this.userCategory.user_category == 5) {
          if (i.value !== "total_cost") {
            return true;
          }
        } else {
          return true;
        }
      });
    },
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getTimesheetList",
      "getvendorDropdown",
      "timesheetDetails",
      "updateTimesheetStatus",
      "activeStatus",
      "updateApplication",
    ]),
    openUpdate(item) {
      this.openStatusDialog = true;
      this.applicationItem = item;
    },
    updateApplicationStatus() {
      if (this.$refs.form.validate()) {
        this.updateApplication({
          record_id: this.applicationItem.id,
          status: this.selectedApplicationStatus,
          comment: this.comment,
        }).then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.openStatusDialog = false;
          this.editDetails(this.item);
        });
      }
    },
    confirmAction() {
      this.activeStatus(this.rejectedItem.id).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data.message,
        });
        this.fetchList();
      });
      this.dialogConfirm = false;
    },
    confirmStatusChange(item) {
      this.rejectedItem = item;
      this.dialogConfirm = true;
    },
    closeConfirm() {
      let index = this.list.findIndex((e) => {
        return e.id == this.rejectedItem.id;
      });
      this.list[index].status = "Open";

      this.dialogConfirm = false;
    },
    updateStatusAction(item) {
      this.updateItem = item;
      this.updatePopup = true;
    },
    updateStatus() {
      if (this.selectedStatus) {
        this.updateTimesheetStatus({
          record_id: this.updateItem.id,
          status: this.selectedStatus,
          comment: this.rowcomment,
        }).then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.updatePopup = false;
          this.fetchList();
        });
      }
    },
    getvendorList() {
      if (this.vendors.length === 0 && this.userCategory.user_category === 3) {
        this.vendorLoader = true;

        this.getvendorDropdown()
          .then((res) => {
            this.vendorLoader = false;
            this.vendors = res.data;
          })
          .catch(() => {
            this.vendorLoader = false;
          });
      }
    },
    editDetails(item) {
      let id;
      if (this.item == undefined) {
        this.itemFound = item;
        this.item = item;
        id = item.id;
      } else {
        id = item.id;
      }
      let data = {
        id: id,
        ...this.optionsDetails,
      };
      this.timesheetDetails(data).then((res) => {
        this.detailsData = res.data.records;
        this.dialog = true;
        this.totals = res.data.total;
      });
    },
    closeDetailsPopup() {
      this.detailsPopup = false;
      this.fetchpreALertList();
      this.allClear();
    },
    clearInput(val) {
      if (val == "from_date") {
        this.from_date = "";
      } else if (val == "to_date") {
        this.to_date = "";
      } else if (val !== null) {
        val = "";
      }
    },
    allFilters() {
      this.loader = true;
      let obj = {
        vendor_id: this.selectedVendor,
        from_date: this.from_date,
        to_date: this.to_date,
        status: this.statusArr,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    pendingApproval() {
      this.statusArr = [0, 3];
      this.searchAll();
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getTimesheetList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    allClear() {
      this.from_date = null;
      this.to_date = null;
      this.filtersArr = [];
      this.statusArr = [];
      this.selectedVendor = null;
      this.fetchList();
    },
    callFun() {
      this.list = [];
      this.loader = true;
      let params = {
        vendor_id: this.selectedVendor,
        ...this.options,
        ...this.filtersArr,
      };
      this.getTimesheetList(params)
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;

          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    fetchList() {
      this.callFun();
    },
    reset() {
      this.file = "";
      this.boe_no = "";
      this.addDialog = false;
      this.dialog = "";
      this.$refs.form?.reset();
      this.$refs.form1?.reset();
      this.formData = {};
      this.editedIndex = -1;
      this.orderdetailsRow = false;
    },

    close() {
      this.dialog = false;
      this.exitdialog = false;
      this.allClear();
    },
  },
};
</script>
<style scoped>
.custom-footer {
  font-size: 17px;
  font-weight: bold;
  width: 100%;
  border-collapse: collapse;
  background-color: #add8e64f;
  margin-top: 70px; /* Adjust as needed */
  border: 1px solid gray; /* Add border styles as needed */
}
.custom-footer td {
  padding: 16px;
  background-color: #add8e64f;
  /* width: 500px; */
  border-top: 1px solid lightgray;
  text-align: left; /* Center the content */
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
